import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { AppService } from "@root/app.service";

type WidgetCount = Partial<{
  today_task_count: number;
  tomorrow_task_count: number;
  box_count: number;
}>;

@Component({
  selector: "host-draggable-operator",
  templateUrl: "./draggable-operator.component.html",
  styleUrls: ["./draggable-operator.component.scss"],
})
export class DraggableOperatorComponent implements OnInit {
  @Input() widgetType: "status" | "price" = "status";
  // @Input() displayWidget = false;
  @Input() displayStock = true;
  @Input() displayThousandsSep = false;
  @Input() displayLeadPrice = false;
  @Input() displayLeadRules = false;
  @Input() widgetCount: WidgetCount = {};

  @Output() onClickScroll: EventEmitter<string> = new EventEmitter();
  @Output() onClickWidget: EventEmitter<string> = new EventEmitter();
  @Output() onClickDeposit: EventEmitter<string> = new EventEmitter();

  @Output() onClickShare: EventEmitter<"entire" | "partial" | "link"> = new EventEmitter();

  @Output() onToggleDisplayStock = new EventEmitter();
  @Output() onToggleDisplayThousandsSep = new EventEmitter();
  @Output() onToggleDisplayLeadPrice = new EventEmitter();
  @Output() onToggleDisplayLeadRules = new EventEmitter();

  get isInternational() {
    return this.app.app.international;
  }

  constructor(private app: AppService) {}

  ngOnInit() {}

  imageUrl(name: string) {
    const prefix = "/assets/calendar/";
    return this.isInternational ? `${prefix}${name}_en.png` : `${prefix}${name}.png`;
  }
}
